var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.playerReady)?_c('div',{attrs:{"id":"app"}},[(_vm.gameDataLoaded)?_c('div',[_c('router-view')],1):_c('div',[_vm._v(" Loading... ")])]):_c('div',[_c('network-select')],1)}
var staticRenderFns = []

export { render, staticRenderFns }